import styled from 'styled-components';

export const NotesSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: ${({ theme }) => theme.uiBricks?.pageBackgroundColor || '#ffffff'};
    border: ${({ theme }) =>
        `1px solid ${theme.uiBricks?.tradeInSummaryTradeInVehicleVehicleInfoKbbTradeInAdvisorContainerBorderColor || '#d6d8db'}`};
    border-radius: 12px;
    padding: 16px 20px;
`;
